/** Toast-Benachrichtigungen als Signal (kurze, dezente Hinweise). */

import { signal } from "@preact/signals";

export interface Toast {
  id: number;
  msg: string;
  type: "ok" | "err" | "";
}

export const toasts = signal<Toast[]>([]);
let counter = 0;

export function toast(msg: string, type: Toast["type"] = ""): void {
  const id = ++counter;
  toasts.value = [...toasts.value, { id, msg, type }];
  setTimeout(() => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }, 3400);
}
